import { fetcher } from "@website/fetcher/fetcher";
import {
  AuthVerifyOtpBodyType,
  AuthVerifyOtpResponseType
} from "@website/widget/login/services/auth-verify-otp/auth-verify-otp.types";

export const AuthVerifyOtpUrl = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/auth/verify-otp`;

export const AuthVerifyOtpService = (
  body: AuthVerifyOtpBodyType
): Promise<AuthVerifyOtpResponseType> =>
  fetcher({
    url: AuthVerifyOtpUrl,
    method: "POST",
    data: body
  }).then(({ data }) => data);
